import { readAuthMeta } from '../context/AuthSync';

const BASE_URL = process.env.REACT_APP_URL_PAYM;

const requestNew = {
  email: "",
  membership: "",//--automatic,manual
  displayName: "",
  phone: "",
  numberCard: "",
  expiry_month: "",
  expiry_year: "",
  cvc: "",
  name: "",
  address_line1: "",
  address_city: "",
  address_country: "",
  ip_address : ""
};

export async function payMembership( requestBody ) {
  const [month, year] = requestBody.expireDate.split("/");
  const fullYear = `20${year}`;

  const meta = readAuthMeta();
  const sessionEmail = meta?.email || meta?.user?.email;

  if (!sessionEmail) {
    throw new Error("Please authenticate to continue with the payment.");
  }

  requestNew.email = requestBody.email;
  requestNew.membership = "automatic";
  requestNew.displayName = requestBody.cardName;
  requestNew.phone = "";
  requestNew.numberCard = requestBody.cardNumber;
  requestNew.expiry_month = month;
  requestNew.expiry_year = fullYear;
  requestNew.cvc = requestBody.cvv;
  requestNew.name = requestBody.cardName;
  requestNew.address_line1 = requestBody.address;
  requestNew.address_city = requestBody.city;
  requestNew.address_country = requestBody.country;
  requestNew.ip_address = "";
  
  return fetch(BASE_URL+`/payments/subscriptions/newClient/${encodeURIComponent(sessionEmail)}`, {
    method: "POST",
    body: JSON.stringify(requestNew),
    headers: {
      "Content-Type": "application/json",
    }
    
  });
}


export async function delteMembership( email ) {
  return fetch(BASE_URL+"/payments/deleteSubscription/"+email, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    }
    
  });
}

export async function getMembership( email ) {
  const url = `${BASE_URL}/payments/user/infoPayment/${encodeURIComponent(email)}`;

  return fetch(url, { headers: { 'Content-Type': 'application/json'} });
}

export async function getMembershipGeneral( email ) {
  const url = `${BASE_URL}/payments/user/infoPayment/${encodeURIComponent(email)}`;
  try {
    const res = await fetch(url, { headers: { 'Content-Type': 'application/json'} });
    if (!res.ok) throw new Error(`Fetch invoices failed: ${res.status}`);
    const data = await res.json().catch(() => ({}));

    return data;

  } catch (err) {
    console.error('Error fetching invoices', err);

    const fallback = {
      paymentHistory: [
        {
          planName: '',
          status: 'Failed',
          scheme: '',
          numberCard: '',
          planAmount: '',
          nextBillingDate: '',
          paymentHistory: []
        }
      ]
    };

    return fallback;

  }
}

export async function updatePaymentMethod(email, paymentData) {
  const [month, year] = paymentData.expireDate.split("/");
  const fullYear = `20${year}`;

  const requestBody = {
    email: email,
    first_name: "",
    last_name: "",
    phone_number: "",
    card: {
        number: paymentData.cardNumber,
        expiry_month: month,
        expiry_year: fullYear,
        cvc: paymentData.cvv,
        name: paymentData.cardName,
        address_line1: "",
        address_city: "",
        address_country: ""
    }
  };

  const url = `${BASE_URL}/payments/client`;
  

   return await fetch(url, {
      method: "PUT",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      }
    });

}
